import { Button } from '@Components/button/button'
import PreviousChevron from '@Assets/icons/previous-chevron.svg'

type PreviousButtonProps = {
  onClick: () => void
  show?: boolean
}

/**
 * The Back control in the sticky footer, shared by the claim form and the appointment flow so the
 * two cannot drift apart on its name or its position. Render it before the Next button — tab order
 * follows the DOM, and the footer no longer reverses it in CSS.
 */
export const PreviousButton = ({ onClick, show = true }: PreviousButtonProps) => {
  if (!show) {
    return null
  }
  return (
    <Button
      className="floating-footer__previous-button"
      aria-label="Previous step"
      onClick={onClick}>
      <img src={PreviousChevron} alt="" />
    </Button>
  )
}
